import { store } from "../../../..";
import { updateWebAutomation } from "../webAutomationSlice";

const defaultEnvironmentData = {
  browser: "",
  operatingSystem: "",
  envType: "",
  url: "",
  username: "",
  password: "",
};

function getUpdatedEnvironmentData(locationKey, key, value) {
  const state = store.getState();

  const currentEnvironmentData =
    state["testAutomation"][locationKey]["webAutomation"]["environmentData"];

  return { ...currentEnvironmentData, [key]: value };
}

export const createEnvironmentData = (locationKey) =>
  updateWebAutomation(locationKey, "environmentData", defaultEnvironmentData);

export const setBrowserState = (locationKey, data) => {
  const updatedEnvironmentData = getUpdatedEnvironmentData(locationKey, "browser", data);

  return updateWebAutomation(locationKey, "environmentData", updatedEnvironmentData);
};

export const setOperatingSystemState = (locationKey, data) => {
  const updatedEnvironmentData = getUpdatedEnvironmentData(locationKey, "operatingSystem", data);

  return updateWebAutomation(locationKey, "environmentData", updatedEnvironmentData);
};

export const setEnvTypeState = (locationKey, data) => {
  const updatedEnvironmentData = getUpdatedEnvironmentData(locationKey, "envType", data);

  return updateWebAutomation(locationKey, "environmentData", updatedEnvironmentData);
};

export const setUrlState = (locationKey, data) => {
  const updatedEnvironmentData = getUpdatedEnvironmentData(locationKey, "url", data);

  return updateWebAutomation(locationKey, "environmentData", updatedEnvironmentData);
};

export const setUsernameState = (locationKey, data) => {
  const updatedEnvironmentData = getUpdatedEnvironmentData(locationKey, "username", data);

  return updateWebAutomation(locationKey, "environmentData", updatedEnvironmentData);
};

export const setPasswordState = (locationKey, data) => {
  const updatedEnvironmentData = getUpdatedEnvironmentData(locationKey, "password", data);

  return updateWebAutomation(locationKey, "environmentData", updatedEnvironmentData);
};

export const resetEnvironmentData = (locationKey) =>
  updateWebAutomation(locationKey, "environmentData", defaultEnvironmentData);